import { Component, input, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRCodeComponent } from "angularx-qrcode";
@Component({
  selector: 'lib-qr-code',
  imports: [
    CommonModule,
    QRCodeComponent
  ],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent {
  @ViewChild('qrCodeElement', { static: false }) qrCodeElement!: ElementRef;

  public readonly qrData = input<string>('');
  public readonly width = input<number>(180);
  public readonly margin = input<number>(1);
  public readonly errorCorrectionLevel = input<'L' | 'M' | 'Q' | 'H'>('L');
  public readonly imageSrc = input<string>(null);
  public readonly imageWidth = input<number>(null);
  public readonly imageHeight = input<number>(null);



  /**
   * Downloads the QR code as PNG image
   */
  public downloadQrCode(filename: string = 'qrcode.png'): void {
    const canvas = this.qrCodeElement?.nativeElement?.querySelector('canvas');
    if (canvas) {
      canvas.toBlob((blob: Blob | null) => {
        if (blob) {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }
      }, 'image/png');
    }
  }
}
